import { useMutation } from "@apollo/client";
import {
  Table,
  Thead,
  Tr,
  Th,
  useMediaQuery,
  Tbody,
  Td,
  Button,
  useDisclosure,
  ModalFooter,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FaSync } from "react-icons/fa";
import SyncForm from "../forms/SyncForm";
import ModalWrapper from "../modals/ModalWrapper";
import { SCRAPE_ONLINE_PALENGKE, SCRAPE_PALENGKE_SENTRAL } from "./mutations";

type Props = {};

const formName = "scrapSources";
const ExternalSourceTable = (props: Props) => {
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [source, setSource] = useState<string>();
  const toast = useToast();
  const [scrapeOP, { loading: LoadingOP }] = useMutation(
    SCRAPE_ONLINE_PALENGKE
  );
  const [scrapePS, { loading: LoadingPS }] = useMutation(
    SCRAPE_PALENGKE_SENTRAL
  );

  const onSubmit = (values: any) => {
    if (source === "Online Palengke") {

      return scrapeOP({
        variables: {
          pages: Number(values.pages),
        },
      })
        .then((data: any) => {
          if (data) {
            onClose();

            if (!toast.isActive("active-toast")) {
              toast({
                id: "active-toast",
                title: `Successfuly scraped`,
                status: "success",
                duration: 3000,
                isClosable: true,
                variant: "solid",
              });
            }
          }
        })
        .catch((error) => {
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: error.message,
              description: "Please, try again.",
              status: "error",
              duration: 2000,
              isClosable: true,
              variant: "solid",
            });
          }
        });
    } else if (source === "Palengke Sentral") {
      return scrapePS({
        variables: {
          pages: Number(values.pages),
        },
      })
        .then((data: any) => {
          if (data) {
            onClose();

            if (!toast.isActive("active-toast")) {
              toast({
                id: "active-toast",
                title: `Successfuly scraped`,
                status: "success",
                duration: 3000,
                isClosable: true,
                variant: "solid",
              });
            }
          }
        })
        .catch((error) => {
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: error.message,
              description: "Please, try again.",
              status: "error",
              duration: 2000,
              isClosable: true,
              variant: "solid",
            });
          }
        });
    }
  };

  return (
    <Table variant="simple" size={isLargerThan900 ? "md" : "sm"}>
      <Thead>
        <Tr>
          <Th></Th>
          <Th>Name</Th>
          <Th>URL</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td></Td>
          <Td>Online Palengke</Td>
          <Td>onlinepalengke.com</Td>
          <Td>
            <Button
              leftIcon={<FaSync />}
              onClick={() => {
                setSource("Online Palengke");
                onOpen();
              }}
            >
              Sync
            </Button>
          </Td>
        </Tr>
        <Tr>
          <Td></Td>
          <Td>Palengke Sentral</Td>
          <Td>palengkesentral.com</Td>
          <Td>
            <Button
              leftIcon={<FaSync />}
              onClick={() => {
                setSource("Palengke Sentral");
                onOpen();
              }}
            >
              Sync
            </Button>
          </Td>
        </Tr>
      </Tbody>

      <ModalWrapper
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        title={`Sync ${source}`}
      >
        <SyncForm onSubmit={onSubmit} formName={formName} />

        <ModalFooter>
          <Button mr="3" w={isLargerThan900 ? "50" : "full"} onClick={onClose}>
            Cancel
          </Button>
          <Button
            w={isLargerThan900 ? "50" : "full"}
            form={formName}
            colorScheme="whatsapp"
            type="submit"
            isLoading={LoadingOP || LoadingPS}
            isDisabled={LoadingOP || LoadingPS}
          >
            Scrape
          </Button>
        </ModalFooter>
      </ModalWrapper>
    </Table>
  );
};

export default ExternalSourceTable;
